export enum ActionCode {
    CBHESP = 'CBHE-SP',
    CBHEJP = 'CBHE-JP'
}